import { render } from "./Pos.vue?vue&type=template&id=45655d26&scoped=true"
import script from "./Pos.vue?vue&type=script&lang=js"
export * from "./Pos.vue?vue&type=script&lang=js"

import "./Pos.vue?vue&type=style&index=0&id=45655d26&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/ZEPPELIN/mi-stock-zeppelin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45655d26"]])

export default __exports__